export default __webpack_public_path__ + "static/lighthouse-c26e1bc66c35c0fe87d2c71cbe2d94f0.jpg";